import { Button, message } from "antd";
import JoditEditor from "jodit-react";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { addCMSData, getCMSData } from "../../apis/user";
import { useLoader } from "../common/Loader/LoaderProvider";

const PrivacyAndPolicies = () => {
  const [quillValue, setQuillValue] = useState("");
  const editor = useRef(null);
  const loaderContext = useLoader();
  const { showLoader, hideLoader } = loaderContext;
  const dispatch = useDispatch();

  const fetchCMSData = async () => {
    showLoader();
    dispatch(getCMSData("privacy"))
      .then((res) => {
        // console.log("res=>>>>", res);
        if (res.status) {
          console.log("res=>>>>", res?.data?.data?.content);
          setQuillValue(res?.data?.data?.content);
          hideLoader();
        } else {
          hideLoader();
        }
      })
      .finally(() => {
        hideLoader();
      });
  };
  useEffect(() => {
    fetchCMSData();
  }, []);

  const handleSubmit = async () => {
    showLoader();
    const data = {
      type: "privacy",
      content: quillValue,
    };
    dispatch(addCMSData(data))
      .then((res) => {
        if (res.status) {
          console.log("Content updated successfully");
          message.success(res?.data?.message);

          fetchCMSData();
        }
      })
      .finally(() => {
        hideLoader();
      });
  };

  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: "Terms and Conditions",
      buttons: [
        "source",
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "superscript",
        "subscript",
        "ul",
        "ol",
        "outdent",
        "indent",
        "font",
        "fontsize",
        "brush",
        "paragraph",
        "align",
        "undo",
        "redo",
        "table",
        "link",
        "hr",
        // "copyformat",
        "fullsize",
        "selectall",
        "print",
      ], // Removed image and video buttons
      removeButtons: ["image", "video"],
      uploader: { insertImageAsBase64URI: false }, // Disables image upload
      filebrowser: false, // Disables file browsing
    }),
    []
  );

  return (
    <div className="flex flex-col gap-6">
      <div className="h-[500px] overflow-y-auto">
        <JoditEditor
          ref={editor}
          value={quillValue}
          config={config}
          onBlur={(newContent) => setQuillValue(newContent)}
          onChange={(newContent) => setQuillValue(newContent)}
        />
      </div>
      <div className="flex justify-end  mt-8">
        <Button type="primary" onClick={handleSubmit}>
          Submit
        </Button>
      </div>
    </div>
  );
};

export default PrivacyAndPolicies;
